import { getCookieValue } from "../helper/cookies";
export const BETA_COOKIE = "21st_BETA";
export function isBeta() {
    const cookieValue = getCookieValue(BETA_COOKIE);
    return cookieValue ? cookieValue == "true" : false;
}
//# sourceMappingURL=beta.js.map